import { withHydrate } from '@relay/react/hooks';
import { Device, until } from '@helpers/media';
import withRedux from '@helpers/withRedux';
import useMedia from '@hooks/useMedia';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Click2Buy from '../Click2Buy/Click2Buy';
import { ProductNavigationStyles as S } from './ProductNavigation.styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const ProductNavigation = props => {
  const [hasScrolled, setHasScrolled] = useState(false);
  const itemsRef = useRef(null);
  const [items, setItems] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const _activeId = useRef(activeId);
  const [shouldShowMobileClick2Buy, setShouldShowMobileClick2Buy] = useState(false);
  const selectedVariantId = useSelector(x => x.productDetail.selectedVariantAgilityId);
  const variants = useSelector(x => x.productDetail.variants);
  const loadingRelations = useSelector(x => x.productDetail.loadingRelations);
  const selectedVariant = useMemo(() => variants.find(x => x.agilityId === selectedVariantId), [selectedVariantId]);
  const translations = useSelector(x => x.productDetail.translations);
  const [isScrollToTopButtonVisible, setIsScrollToTopButtonVisible] = useState(false);
  const isMobile = useMedia([until(Device.DesktopSmall)], [true], false);
  const handleIntersection = entries => {
    entries.forEach(entry => {
      const targetId = entry.target.getAttribute('data-navigation-id');
      const activeValue = entry.target.getAttribute('data-active');
      const isOpen = activeValue === null || activeValue === 'true';
      if (entry.isIntersecting && isOpen) {
        setActiveId(targetId);
        _activeId.current = targetId;
      }
    });
  };
  useEffect(() => {
    const body = document.querySelector('body');
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 200);

      // The following is the same calculation done in ScrollToTop.tsx
      if (body) {
        setIsScrollToTopButtonVisible(window.scrollY > body.clientHeight / 2);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const newItems = [];
    const elements = Array.from(document.querySelectorAll('[data-navigation-id]'));
    elements.filter(x => x.dataset.navigationTitle).forEach(x => newItems.push({
      title: x.dataset.navigationTitle ?? '',
      anchor: x.dataset.navigationId ?? '',
      element: x
    }));
    setItems(newItems);
  }, [loadingRelations]);
  useEffect(() => {
    const elements = Array.from(document.querySelectorAll('[data-navigation-id]'));
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '-10% 0px -65% 0px'
    });
    elements.forEach(x => observer.observe(x));
  }, []);
  useEffect(() => {
    if (activeId === null || !itemsRef.current) {
      return;
    }
    const target = document.querySelector(`${S.Item}[data-id="${activeId}"]`);
    if (!target) {
      return;
    }
    const targetLeft = target.offsetLeft - itemsRef.current.offsetLeft;
    itemsRef.current.scrollTo({
      left: targetLeft,
      behavior: 'smooth'
    });
  }, [activeId]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(S.Container, {
      isActive: hasScrolled && loadingRelations === false,
      children: /*#__PURE__*/_jsxs(S.Grid, {
        children: [/*#__PURE__*/_jsx(S.Items, {
          ref: itemsRef,
          children: items.map(x => /*#__PURE__*/_jsx(S.Item, {
            isActive: activeId === x.anchor,
            onClick: () => {
              setActiveId(x.anchor);
            },
            "data-id": x.anchor,
            children: /*#__PURE__*/_jsx("a", {
              href: `#${x.anchor}`,
              children: x.title
            })
          }, x.anchor))
        }), !isMobile && /*#__PURE__*/_jsx(Click2Buy, {
          text: translations['custom.click2buy.buttontext'],
          articleNumber: selectedVariant?.articleNumber,
          stackAdaptTrackingCode: props.translations['stackadapt.tracking.buynow']
        })]
      })
    }), isMobile && /*#__PURE__*/_jsx(S.MobileOnlyClickToBuyWrapper, {
      show: shouldShowMobileClick2Buy && hasScrolled,
      isScrollToTopButtonVisible: isScrollToTopButtonVisible,
      children: /*#__PURE__*/_jsx(Click2Buy, {
        onInit: () => setShouldShowMobileClick2Buy(true),
        onHide: () => setShouldShowMobileClick2Buy(false),
        text: translations['custom.click2buy.buttontext'],
        articleNumber: selectedVariant?.articleNumber,
        stackAdaptTrackingCode: props.translations['stackadapt.tracking.buynow']
      })
    })]
  });
};
export const clientConfig = {
  hydrate: 'always'
};
export default withHydrate(withRedux(ProductNavigation), 'ProductNavigation', 'hybrid');
